import { commonFilter } from './filter';

const pageId = '24031';

export default {
  pageName: 'Key Metrics',
  pageId,
  pagePath: '/opinion/Overview/KeyMetrics',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    KM_ShowCompetitor: {
      buttonId: '24031001',
    },
    KM_Download: {
      buttonId: '24031002',
    },
    KMMS_TypeTAB: {
      buttonId: '24031101',
    },
    KMMS_CompetitorRanking: {
      buttonId: '24031102',
    },
    KMMS_GotoCompetitor: {
      buttonId: '24031103',
    },
    KMMS_ByMetricsType: {
      buttonId: '24031104',
    },
    KMMS_Metrics: {
      buttonId: '24031105',
    },

    KMGS_StoreMetricsTAB: {
      buttonId: '24031402',
    },
    KMGS_RatingMetricsTAB: {
      buttonId: '24031403',
    },
    KMGS_CompetitorRanking: {
      buttonId: '24031404',
    },
    KMGS_ByMetricsType: {
      buttonId: '24031405',
    },
    KMGS_PC_AllReviewsRanking: {
      buttonId: '24031709',
    },
    KMGS_PC_RecentReviewsRanking: {
      buttonId: '24031710',
    },

    KMCM_TypeTAB: {
      buttonId: '24031501',
    },
    KMCM_GotoPage: {
      buttonId: '24031502',
    },
    KMCM_Metrics: {
      buttonId: '24031503',
    },
    KMCM_ByMetricsType: {
      buttonId: '24031504',
    },
    KMCM_CompetitorRanking: {
      buttonId: '24031505',
    },
    KMPR_CompetitorRanking: {
      buttonId: '24031602',
    },
    KMLG_EventSetting: {
      buttonId: '24031305',
    },
    KMLG_EventSetting_axis: {
      buttonId: '24031306',
    },
    KMLG_EventSetting_Bubble: {
      buttonId: '24031307',
    },
    KMLG_Eventaxis: {
      buttonId: '24031308',
    },
    KMLG_EventaxisMore: {
      buttonId: '24031309',
    },
    KMMS_EventClick: {
      buttonId: '24031310',
    },
    KMMS_BarClick: {
      buttonId: '24031311',
    },
    KMMS_EventSelectBox: {
      buttonId: '24031312',
    },
    KMMS_EventTypeSetting: {
      buttonId: '24031313',
    },
    ...commonFilter,
  },
  card: {
    KMMS: {
      vs: {
        buttonId: '24031106',
      },
      pie: {
        buttonId: '24031107',
      },
      table: {
        buttonId: '24031108',
      },
      line: {
        buttonId: '24031109',
      },
      stack_line: {
        buttonId: '24031110',
      },
      bar: {
        buttonId: '24031111',
      },
      download: {
        buttonId: '24031112',
      },
    },
    KMCN: {
      title: {
        buttonId: '24031201',
      },
      'sentiment-s-bar': {
        buttonId: '24031202',
      },
      line: {
        buttonId: '24031203',
      },
      pie: {
        buttonId: '24031204',
      },
    },
    KMLG: {
      title: {
        buttonId: '24031301',
      },
      'sentiment-s-bar': {
        buttonId: '24031302',
      },
      line: {
        buttonId: '24031303',
      },
      pie: {
        buttonId: '24031304',
      },
    },
    KMGS: {
      title: {
        buttonId: '24031401',
      },
      vs: {
        buttonId: '24031406',
      },
      table: {
        buttonId: '24031407',
      },
      line: {
        buttonId: '24031408',
      },
      stack_line: {
        buttonId: '24031409',
      },
      bar: {
        buttonId: '24031410',
      },
      download: {
        buttonId: '24031411',
      },
    },

    KMGS_PC: {
      title: {
        buttonId: '24031701',
      },
      vs: {
        buttonId: '24031702',
      },
      pie: {
        buttonId: '24031703',
      },
      table: {
        buttonId: '24031704',
      },
      line: {
        buttonId: '24031705',
      },
      stack_line: {
        buttonId: '24031706',
      },
      bar: {
        buttonId: '24031707',
      },
      download: {
        buttonId: '24031708',
      },
    },

    KMCM: {
      vs: {
        buttonId: '24031406',
      },
      table: {
        buttonId: '24031407',
      },
      line: {
        buttonId: '24031408',
      },
      stack_line: {
        buttonId: '24031409',
      },
      bar: {
        buttonId: '24031410',
      },
      download: {
        buttonId: '24031411',
      },
    },

    KMCMA: {
      pie: {
        buttonId: '24031512',
      },
      table: {
        buttonId: '24031513',
      },
      line: {
        buttonId: '24031514',
      },
      stack_line: {
        buttonId: '24031515',
      },
      bar: {
        buttonId: '24031516',
      },
      download: {
        buttonId: '24031517',
      },
    },

    KMPR: {
      title: {
        buttonId: '24031601',
      },
      vs: {
        buttonId: '24031603',
      },
      line: {
        buttonId: '24031604',
      },
      download: {
        buttonId: '24031605',
      },
    },
  },
};
